import { Controller } from "@hotwired/stimulus"

// Phase 2.11 Tier 1 — Asset detail surface (no-op shell).
//
// The detail page renders three panels (header, warranty, history) plus
// a right-rail action stack. Tier 1 has no client-side tab switching —
// the panels render inline. This controller exists so the detail markup
// can attach `data-controller="asset-detail-tabs"` for a future tier
// (Deliverables / Checklist / Linked Records tabs land in Tier 4) to
// hook into without changing the wrapper element.
export default class extends Controller {
}
